<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-0': $vuetify.breakpoint.xs,'pa-4' : $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{$t("Главная")}}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <v-layout row wrap align-center
                          justify-space-between mb-4 :class="{'mx-3': $vuetify.breakpoint.xs}"
                >
                    <v-flex sm6 xs12>
                        <h1 class="section-title-main my-3 font-weight-regular">{{$t("Избранное")}}</h1>
                    </v-flex>
                    <v-flex sm6 xs12>
                        <inputIcon v-model="fav_search" class="layout row search--no-border" icon_name="search"
                                   :placeholder="$t('Поиск по разделу')"
                        />
                    </v-flex>
                </v-layout>
                <v-layout row wrap align-center
                          justify-space-between :class="{'mb-3': $vuetify.breakpoint.smAndDown, 'mb-5 ': $vuetify.breakpoint.mdAndUp}"
                >
                    <v-flex md9 sm12 class="">
                        <v-tabs
                            v-model="active"
                            slot="extension"
                            color="white"
                            slider-color="#e2173d"
                            class="pr-4 tabs__bottom-border"
                        >
                            <v-tab href="#all">
                                <v-layout row wrap align-center>
                                    <v-flex>{{$t("Все")}}</v-flex>
                                </v-layout>
                            </v-tab>
                            <v-tab href="#news" width="260px">
                                <v-layout row wrap align-center>
                                    <v-flex>{{$t("Новости")}}</v-flex>
                                </v-layout>
                            </v-tab>
                            <v-tab href="#events">
                                <v-layout row wrap align-center>
                                    <v-flex>{{$t("Мероприятия")}}</v-flex>
                                </v-layout>
                            </v-tab>
                            <v-tab href="#actions">
                                <v-layout row wrap align-center>
                                    <v-flex>{{$t("Маркетинговые акции")}}</v-flex>
                                </v-layout>
                            </v-tab>
                            <v-tab href="#database">
                                <v-layout row wrap align-center>
                                    <v-flex>{{$t("База знаний")}}</v-flex>
                                </v-layout>
                            </v-tab>
                        </v-tabs>
                    </v-flex>
                    <v-flex md3 sm6 xs12
                            :class="{'mt-3': $vuetify.breakpoint.smAndDown}"
                    >
                        <div class="grey-text mb-2"></div>
                        <v-select
                            :items="[$t('Сначала новые'),$t('Сначала старые')]"
                            solo
                            append-icon=""
                            :label="$t('Сначала новые')"
                            class="input"
                            @change="sorting_by_date($event)"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                </v-layout>
                <v-layout class="pb-5">
                    <v-flex xs12>
                        <v-tabs-items>
                            <v-tab-item>
                                <v-card flat>
                                    <div class="news__wrap">
                                        <news v-for="(item, idx) in favourites" :key="idx" :content="item"
                                              :label_class="label_class(item.type)"
                                        />
                                    </div>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-flex>
                </v-layout>
                <v-layout v-if="fav_pages>1" justify-end align-center
                          wrap
                          :class="{'mx-3': $vuetify.breakpoint.xs}"
                >
                    <v-flex md5 sm7 xs12
                            mb-4
                    >
                        <div class="text-xs-center">
                            <v-pagination
                                v-model="page"
                                :length="fav_pages"
                                :total-visible="$vuetify.breakpoint.xs ? 4 : 5"
                                prev-icon="arrow_back_ios"
                                next-icon="arrow_forward_ios"
                            />
                        </div>
                    </v-flex>
                    <v-flex md4 sm5 xs12
                            mb-4
                    >
                        <v-select
                            :items="$vuetify.breakpoint.mdAndUp ? [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50'),$t('Показывать по 100')]
                            : [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50')]"
                            solo
                            append-icon=""
                            :label="$t('Показывать по 10')"
                            class="input"
                            @change="show_number($event, 10)"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                </v-layout>
            </v-layout>
        </div>
        <v-dialog :value="unfavourite_modal" max-width="550">
            <unfavouriteModal />
        </v-dialog>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import labelTopic   from '@/components/ui/labels/label_topic';
import unfavouriteModal from './Favourites_modal';
import news from '@/components/blocks/news/news_page_item';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    inputIcon,
    labelTopic,
    news,
    unfavouriteModal,
  },
  data() {
    return {
      value: [],
    };
  },
  computed: {
    ...mapGetters('favourites/breadcrumbs', [
      'breadcrumbs',
    ]),
    ...mapGetters('favourites', [
      'favourites',
      'selected_page',
      'fav_pages',
      'selected_number',
      'tab',
      'unfavourite_modal',
      'filtered_by_type',
      'types',
      'search_string',
    ]),
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        this.SET_SELECTED_PAGE($event);
        this.get_favorites();
        return;
      },
    },
    active: {
      get() {
        return this.tab;
      },
      set($event) {
        this.SET_ACTIVE_TAB($event);
        this.get_favorites();
        return;
      },
    },
    fav_search: {
      get() {
        return this.search;
      },
      set($event) {
        this.SEARCH_STRING($event.target.value);
        this.get_favorites();
        return;
      },
    },
  },
  mounted() {
    this.get_favorites();
  },
  methods: {
    ...mapMutations('favourites', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_SELECTED_PAGE',
      'SET_ACTIVE_TAB',
      'CLEAR_PAGES',
      'SEARCH_STRING',
    ]),
    ...mapActions('favourites', [
      'show_number',
      'sorting_by_date',
      'get_favorites',
    ]),
    label_class(type) {
      if (type == 'news') {
        return 'section-label--green';
      } else if (type == 'event') {
        return 'section-label--grey';
      } else if (type == 'actions') {
        return 'section-label--blue';
      }
      return 'section-label--red';
    },
  },
};
</script>
